export default {
    task: {
        getMyCash: 'Get My Cash',
        chances: 'Chances Left',
        tips: 'Tips to get cards',
        daily: 'Daily check-in',
        watch: 'Watch any video',
        share: 'Share the contest',
        free: 'Free cash and card +1',
        done: 'DONE',
        go: 'GO',

        success: 'SUCCESSFULLY',
        checkIn: 'Checked in',
        successCheckIn: 'Successfully Checked in!',
        successWatched: 'Successfully Watched! ',
        successShared: 'Successfully Shared!',
        won: 'You Won',
        card: 'Card',
        msg: 'The money has been saved to your account',
        ok: 'OK',
        nochance: "You haven't finished all",
        cards: '4-cards ',
        collection:'collection',
        watchVideo:'Watch video ',
        toGet:'to get more card'
    },
    
    rules: {
        ruleTitle: "Rules",
        validityDate: "Validity Date: March 8th,2020 - March 15th,2020",
        prizeRedeem: "Prize Redeem: Users can withdraw their cash once the balance reaches 15Rs, the transaction will be completed within 7 workdays",
        gameRule:{
            title:"Game Rules:",
            ruleList: [
                "1. Users can get CASH and 1 card when they done daily check-in",
                "2. Users can get CASH and 1 card when they finish watching any video per day",
                "3. Users can get CASH and 1 card when they finish sharing the activity to WhatsApp group or Facebook or Instagram and so on",
                "4. Once collect all 4 cards, users can get a chance to draw a lottery. Every lucky draw is a 100%-Sure-Win lucky draw from a cash pond of 3 million Rupees, each user can draw 20000 Rs at most"
            ]
        },
        msg:"SHAREit reserves all the right for the final explanation"
    },
    share: {
        title:"*Not Kidding, buddy, this Holi,SHAREit 30 Lakhs real cash Giveaway!*😊\n*Join me and watch videos to get up to 20000Rs, everybody 100% wins.*💰\n*I've already got Free cash,it's 100% true.*\n*Let's join in the SHAREit Holi contest now!*💕👇🏻👇🏻👇🏻"
    }
}